import React from 'react';
import Icon from '../Partials/Icon';

class SocialShare extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const postUrl = window.location.origin + this.props.post.url;
        const blogName = window.blogTitle ?? 'den här bloggen';

        return (
            <div className="social_share">

                {/* Facebook */}
                <a title="Dela på facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(postUrl)}`} 
                    // (TODO:share) Check if we want to use this instead in the future
                    // onClick={() => {window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;}}
                    className="social_share__item social_share__item--facebook" target="_blank" rel="noreferrer">
                    <Icon type="facebook_circle" />
                </a>

                {/* X (Twitter) */}
                <a title="Dela på X" href={`https://x.com/share?url=${encodeURI(postUrl)}`}
                    className="social_share__item social_share__item--x" target="_blank" rel="noreferrer">
                    <Icon type="x_circle" />
                </a>

                {/* Pinterest */}
                <a title="Pinna på pinterest" href={`${window.location.origin}/predirect/?url=${encodeURIComponent(postUrl)}`}
                    className="social_share__item social_share__item--pin" target="_blank" rel="noreferrer noindex">
                    <Icon type="pinterest_circle" />
                </a>

                {/* Mail */}
                <a title={`Maila bloggtips om ${blogName}`} href={`mailto:someone@domain.com?subject=${encodeURIComponent(`Bloggtips från ${blogName}`)}&body=${encodeURIComponent(`Hej,\nJag vill tipsa dig om ett blogginlägg från ${blogName}:\n${postUrl}`)}`}
                    className="social_share__item social_share__item--mail">
                    <Icon type="mail_circle" />
                </a>

                {/* Bloglovin */}
                {typeof window.blogLovin !== 'undefined' &&
                <a title="Följ på Bloglovin" href={`${window.blogLovin}`}
                    className="social_share__item social_share__item-blogLovin"
                    target="_blank" rel="noreferrer">
                    <Icon type="bloglovin_square" />
                </a>
                }
            </div>
        )
    }
}

export default SocialShare;